import React from 'react';
import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Flex,
    Link,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Text } from '../../../../../../ui-components';
import { sanitizeHtml } from '../../../../../content-asset/sanitize-html';
import { ExpandIcon } from '../ExpandIcon';
import styles from '../MenuCategoryMobile.module.scss';
import type { Categories, Category } from '../../../../../../bff-api/categories/model/category';

interface Props {
    categories: Categories;
    lastSelected?: Category | null;
}

export const MenuCategoryMobileLevel34: React.FC<Props> = ({ categories, lastSelected }) => (
    <Flex flexDirection="column">
        {lastSelected?.showShopAllLink ? (
            <Link
                href={lastSelected.url}
                data-testid={`header.menu.mobile.category.${lastSelected.ID}.link`}
                className="px-4 py-3"
            >
                <Text>
                    <FormattedMessage
                        id="header.shop.all"
                        defaultMessage="Shop All {category}"
                        values={{
                            category: lastSelected.displayName,
                        }}
                    />
                </Text>
            </Link>
        ) : null}

        <Accordion allowToggle variant="slt-mobile">
            {categories.map((category) => (
                <AccordionItem
                    key={category.ID}
                    data-testid={`header.menu.mobile.category.${category.ID}`}
                >
                    {({ isExpanded }): React.ReactNode => (
                        <>
                            <Flex
                                data-testid={`header.menu.mobile.category.${category.ID}.title`}
                                role="heading"
                                alignItems="center"
                                paddingX={4}
                                paddingY={3}
                            >
                                <AccordionButton>{category.displayName}</AccordionButton>

                                <ExpandIcon id={category.ID} isExpanded={isExpanded} />
                            </Flex>

                            <AccordionPanel
                                data-testid={`header.menu.mobile.category.${category.ID}.content`}
                                background="slt-black.50"
                                display="flex"
                                flexDirection="column"
                                rowGap={4}
                            >
                                {category.subCategories.map((catLevel4) => (
                                    <Link
                                        data-testid={`header.menu.mobile.category.${catLevel4.ID}.link`}
                                        key={catLevel4.ID}
                                        href={catLevel4.url}
                                    >
                                        <Text size="small">{catLevel4.displayName}</Text>
                                    </Link>
                                ))}
                            </AccordionPanel>
                        </>
                    )}
                </AccordionItem>
            ))}
        </Accordion>

        {lastSelected?.headerMenuBanner1 ? (
            <Flex
                data-testid={`header.menu.mobile.category.lvl3.${lastSelected.ID}.banner1`}
                direction="column"
                textStyle="slt-base"
                rowGap={4}
                paddingTop={8}
                paddingBottom={4}
                paddingX={4}
                className={styles.menu_banner}
                dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(lastSelected.headerMenuBanner1),
                }}
            />
        ) : null}
    </Flex>
);

MenuCategoryMobileLevel34.propTypes = {
    categories: PropTypes.any.isRequired,
    lastSelected: PropTypes.any,
};

MenuCategoryMobileLevel34.defaultProps = {
    lastSelected: null,
};
